import { useScreenSize } from '@hooks/useScreenSize';
import { Stack } from '@mui/material';
import { BlotterWidget } from '@shared/components/BlotterWidget';
import { useUserContext } from '@shared/contexts/UserContextProvider';
import { useApi } from '@shared/hooks/useApi';
import { PRODUCTS_FILTERS, PRODUCT_COLUMNS } from '@shared/protos/options';
import { checkIsInternalUser } from '@utils/permissions';
import { ColDef } from 'ag-grid-enterprise';
import { NavigateFunction, useNavigate } from 'react-router-dom';

const getRowId = ({ data }): string => data?.id?.toString();

const defaultColDef = (navigate: NavigateFunction) => {
  return {
    sortable: true,
    filter: false,
    floatingFilter: false,
    resizable: true,
    width: 150,
    onCellClicked(event) {
      if (event.column.getColId() === 'symbol') {
        navigate(`/reference/products/${event.data.symbol}`);
      }
    },
    cellStyle(params) {
      if (params.column.getColId() === 'symbol') {
        return { cursor: 'pointer' };
      }
      return null;
    },
  } as ColDef;
};

const Products = () => {
  const { apiClient } = useApi();
  const dataLoader = apiClient?.userProductsLoader();
  const navigate = useNavigate();
  const user = useUserContext();
  const { isMobile } = useScreenSize();

  const isOnyxUser = checkIsInternalUser(user);
  if (!dataLoader) return null;

  return (
    <Stack
      direction="column"
      flex={1}
      position="relative"
      sx={{ width: '100%', height: '100%', paddingBottom: isMobile ? 10 : 0, overflow: 'scroll' }}
    >
      <BlotterWidget
        dataLoader={dataLoader}
        columnDefs={PRODUCT_COLUMNS.filter(col => isOnyxUser || col.field !== 'mdx_name')}
        getRowId={getRowId}
        filters={PRODUCTS_FILTERS}
        defaultColDef={defaultColDef(navigate)}
        enableCellTextSelection
        usePagination
        autoSizeStrategy={{
          type: 'fitCellContents',
          colIds: ['full_name'],
        }}
      />
    </Stack>
  );
};

export default Products;
